module.exports = __webpack_public_path__ + "img/tab.c14dc6b4.jpg";